import { Link, Text } from '@chakra-ui/react'
import React from 'react'
import { AiOutlineCloudDownload } from 'react-icons/ai'
import Iframe from 'react-iframe'

export const DownloadPDFDriveLink: React.FC<{ driveId: string, children?: React.ReactNode }> = (props) => {
  return (
    <Link
      color='green'
      href={`https://drive.google.com/uc?export=download&id=${props.driveId}`}
      download
    >
      <AiOutlineCloudDownload display='inline' /> {props.children}
    </Link>
  )
}

export const UnderscoredText: React.FC<{children?: React.ReactNode}> = (props) => {
  return (
    <Text mb={2} as='span' textDecoration={'underline'}>
      {props.children}
    </Text>
  )
}

export const StandardLinkToBlank: React.FC<{ href: string, children?: React.ReactNode }> = (props) => {
  return (
    <Link href={props.href} target='_blank' textDecoration={'underline'}>
      {props.children}
    </Link>
  )
}

export const EmbedYoutubeVideo: React.FC<{ videoHref: string, children?: React.ReactNode }> = (props) => {
  return (
    <Iframe
      styles={{margin: '12px 0px'}}
      url={props.videoHref}
      width='100%'
      height='450px'
      frameBorder={0}
      allowFullScreen={true}
    ></Iframe>
  )
}
